import script from "./MapMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MapMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./MapMenuItem.vue?vue&type=style&index=0&id=53187250&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53187250"]])

export default __exports__